import {PROFILE_FIELD_NAMES} from "./ProfileEnum";

export interface Option {
  name: string;
  value: string;
}

const options: {[key: string]: Option[]} = {
  _gender_options: [
    {"name": "Male", "value": "male"},
    {"name": "Female", "value": "female"},
    {"name": "Transgender", "value": "transgender"},
  ],
  _relation_ship_status_options: [
    {"name": "Married", "value": "Married"},
    {"name": "Single", "value": "Single"},
  ],
  _education_options: [
    {"name": "Class 7 or below", "value": "Class 7 or below"},
    {"name": "Class 8 to Class 11", "value": "Class 8 to Class 11"},
    {"name": "Class 12 or Diploma", "value": "Class 12 or Diploma"},
    {"name": "Graduate or Post Graduate", "value": "Graduate or Post Graduate"},
  ],
  _emi_options: [
    {"name": "Yes", "value": "Yes"}, {"name": "No", "value": "No"}],
  employment_type_options: [
    {"name": "Self Employed", "value": "SELF_EMPLOYED"}],
  _employer_type: [
    {"name": "Private Limited", "value": "PRIVATE_LIMITED"},
    {"name": "Public Limited", "value": "PUBLIC_LIMITED"}],
  _salary_mode_options: [
    {"name": "Bank Transfer", "value": "BANK_TRANSFER"},
    {"name": "Cheque", "value": "CHEQUE"},
    {"name": "Cash", "value": "CASH"}],
  _loan_required_for_options: [
    {"name": "Rental Deposit", "value": "Rental Deposit"},
    {"name": "Medical", "value": "Medical"},
    {"name": "Electronics", "value": "Electronics"},
    {"name": "Marriage", "value": "Marriage"},
    {"name": "Repay old loan", "value": "Repay old loan"},
    {"name": "Education", "value": "Education"},
    {"name": "Vehicle Purchase", "value": "Vehicle Purchase"},
    {"name": "New Business", "value": "New Business"},
    {"name": "Other", "value": "Other"}
  ],
  _residence_type_options: [{"name": "Rented", "value": "Rented"},
    {"name": "Leased", "value": "Leased"}, {"name": "PG", "value": "PG"},
    {"name": "Company House", "value": "CompanyHouse"}, {"name": "Own House", "value": "OwnHouse"}],
  _company_type_options: [
    {"name": "PARTNERSHIP", "value": "PARTNERSHIP"},
    {"name": "LLP", "value": "LLP"},
    {"name": "PRIVATE LIMITED", "value": "PRIVATE_LIMITED"},
    {"name": "PUBLIC LIMITED", "value": "PUBLIC_LIMITED"},
    {"name": "MNC", "value": "MNC"},
    {"name": "PROPRIETORSHIP", "value": "PROPRIETORSHIP"},
    {"name": "GOVERNMENT", "value": "GOVERNMENT"},
    {"name": "TRUSTS", "value": "TRUSTS"},
    {"name": "OTHERS", "value": "OTHERS"}
  ],
  _living_with_options: [
    {"name": "Friends", "value": "FRIENDS"},
    {"name": "Family", "value": "FAMILY"},
    {"name": "Alone", "value": "ALONE"}
  ],
  _payment_frequency_option:[
    {"name": "Weekly", "value": "Weekly"},
    {"name": "Fortnightly", "value": "Fortnightly"},
    {"name": "Monthly", "value": "Monthly"},
  ],
  _interest_only_type:[
    {"name": "0", "value": "0"},
    {"name": "1", "value": "1"},
    {"name": "2", "value": "2"},
  ],
  _business_size: [
    {"name": "Micro", "value": "Micro"},
    {"name": "Small", "value": "Small"},
    {"name": "Medium", "value": "Medium"},
  ],
  _sector: [
    {"name": "Service", "value": "Service"},
    {"name": "Manufacturing", "value": "Manufacturing"},
  ],
  _industry: [
    {"name": "Healthcare and Wellness", "value": "Healthcare and Wellness"},
    {"name": "Food & Beverages", "value": "Food & Beverages"},
    {"name": "Agriculture", "value": "Agriculture"},
    {"name": "Service and Utilities", "value": "Service and Utilities"},
    {"name": "Travel", "value": "Travel"},
    {"name": "Commute", "value": "Commute"},
    {"name": "Retail and Shopping", "value": "Retail and Shopping"},
    {"name": "Financial Services", "value": "Financial Services"},
    {"name": "Currency, Coins and Precious Metals", "value": "Currency, Coins and Precious Metals"},
    {"name": "Grocery and Daily Needs", "value": "Grocery and Daily Needs"},
    {"name": "Fuel", "value": "Fuel"},
    {"name": "Entertainment", "value": "Entertainment"},
    {"name": "Art and Antiques", "value": "Art and Antiques"},
    {"name": "Hospitality", "value": "Hospitality"},
    {"name": "Others", "value": "Others"},
  ],
  _disability_options: [
    {"name": "Yes", "value": "yes"},
    {"name": "No", "value": "no"},
    {"name": "Prefer not to disclose", "value": "prefer not to disclose"},
  ],
};

const getLabelForProfileFieldOptions = (fo: Option[]) => {
  return fo.map((foItem) => ({...foItem, label: foItem.name, id: foItem.value, required: true}));
};

export const ProfileFieldOption = {
  [PROFILE_FIELD_NAMES.GENDER]: getLabelForProfileFieldOptions(options["_gender_options"]),
  [PROFILE_FIELD_NAMES.RELATIONSHIP_STATUS]: getLabelForProfileFieldOptions(options["_relation_ship_status_options"]),
  [PROFILE_FIELD_NAMES.EDUCATION]: getLabelForProfileFieldOptions(options["_education_options"]),
  [PROFILE_FIELD_NAMES.EMPLOYMENT_TYPE]: getLabelForProfileFieldOptions(options["employment_type_options"]),
  [PROFILE_FIELD_NAMES.EMPLOYER_TYPE]: getLabelForProfileFieldOptions(options["_company_type_options"]),
  [PROFILE_FIELD_NAMES.SALARY_MODE]: getLabelForProfileFieldOptions(options["_salary_mode_options"]),
  [PROFILE_FIELD_NAMES.PURPOSE]: getLabelForProfileFieldOptions(options["_loan_required_for_options"]),
  [PROFILE_FIELD_NAMES.RESIDENT_TYPE]: getLabelForProfileFieldOptions(options["_residence_type_options"]),
  [PROFILE_FIELD_NAMES.LIVING_WITH]: getLabelForProfileFieldOptions(options["_living_with_options"]),
  [PROFILE_FIELD_NAMES.PAYMENT_FREQUENCY]: getLabelForProfileFieldOptions(options["_payment_frequency_option"]),
  [PROFILE_FIELD_NAMES.INTEREST_ONLY_PERIOD]: getLabelForProfileFieldOptions(options["_interest_only_type"]),
  [PROFILE_FIELD_NAMES.BUSINESS_SIZE]: getLabelForProfileFieldOptions(options["_business_size"]),
  [PROFILE_FIELD_NAMES.BUSINESS_SECTOR]: getLabelForProfileFieldOptions(options["_sector"]),
  [PROFILE_FIELD_NAMES.INDUSTRY]: getLabelForProfileFieldOptions(options["_industry"]),
  [PROFILE_FIELD_NAMES.PERSON_WITH_DISABILITY]: getLabelForProfileFieldOptions(options["_disability_options"]),
};
